import React from 'react';
import DashboardDropdown from '../DashboardDropdown';
import {TIMEFRAME_OPTIONS} from '../Common';
import CogIcon from 'components/pure/utils/icon/CogIcon';
import {Popover} from 'material-ui/Popover';
import WidgetHeader from '../WidgetHeader';
import SelectField from 'components/pure/utils/form/SelectField';
import WebDataRocksActions from '@store/web-data-rocks/WebDataRocksActions';
import WebDataButton from 'components/utils/WebDataButton';

class SAWHeader extends React.Component {
  constructor(props) {
    super(props);

    this.toggleParameters = this.toggleParameters.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);

    this.state = {
      parametersOpen: false,
    };
  }

  componentDidMount() {
    document.addEventListener('click', this.handleClickOutside, true);
    document.addEventListener('keydown', this.handleKeyPress, true);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleClickOutside, true);
    document.removeEventListener('keydown', this.handleKeyPress, true);
  }

  /**
   * Event handler to close the popup of the user clicks outside the popup
   * @param event
   */
  handleClickOutside(event) {
    if (
      this.parametersPopover &&
      !this.parametersToggle.contains(event.target) &&
      !this.parametersPopover.contains(event.target)
    ) {
      this.setState({
        parametersOpen: false,
      });
    }
  }

  /**
   * Event handler to close the popup if ESC is pressed
   * @param event
   */
  handleKeyPress(event) {
    event = event || window.event;
    let isEscape = false;
    if ('key' in event) {
      isEscape = event.key === 'Escape' || event.key === 'Esc';
    } else {
      isEscape = event.keyCode === 27;
    }
    if (isEscape) {
      this.setState({
        parametersOpen: false,
      });
    }
  }

  toggleParameters() {
    this.setState({
      parametersOpen: !this.state.parametersOpen,
    });
  }

  renderParameters(scorecardOptions, displayScoresOptions) {
    return (
      <div className="parameters" ref={ref => (this.parametersAnchor = ref)}>
        <span
          className="parameters-label"
          onClick={this.toggleParameters}
          ref={ref => (this.parametersToggle = ref)}>
          <CogIcon /> Parameters
        </span>
        {this.state.parametersOpen && (
          <Popover
            className="saw-popover"
            open={true}
            useLayerForClickAway={false}
            anchorEl={this.parametersAnchor}
            canAutoPosition={false}
            anchorOrigin={{horizontal: 'right', vertical: 'bottom'}}
            targetOrigin={{horizontal: 'right', vertical: 'top'}}>
            <div className="parameters-options" ref={ref => (this.parametersPopover = ref)}>
              <div className="parameter-option">
                <span>Scorecard</span>
                <SelectField
                  tether={true}
                  value={this.props.scorecardSelectedOption}
                  options={scorecardOptions}
                  onChange={this.props.scorecardOptionChange}
                />
              </div>
              <div className="parameter-option">
                <span>Scored By</span>
                <SelectField
                  tether={true}
                  value={this.props.scoresSelectedOption}
                  options={displayScoresOptions}
                  onChange={this.props.scoresSelectedOptionChange}
                />
              </div>
            </div>
          </Popover>
        )}
      </div>
    );
  }

  renderScoresDropdown(displayScoresOptions) {
    return (
      <div className="scored-by-container">
        <div className="label">Scored By</div>
        <div className="drop-down">
          <SelectField
            tether={true}
            value={this.props.scoresSelectedOption}
            options={displayScoresOptions}
            onChange={this.props.scoresSelectedOptionChange}
          />
        </div>
      </div>
    );
  }

  webDataOnClick = () => {
    const {managerId} = this.props;
    const widgetConfig = {
      widgetId: this.props.widgetId,
      widgetType: this.props.widgetType,
      startDate: this.props.startDate,
      endDate: this.props.endDate,
      scorecard: this.props.scorecardSelectedOption,
      callStage: this.props.callStageSelectedOption,
      scoresOption: this.props.scoresSelectedOption,
    };
    WebDataRocksActions.fetchData.defer(widgetConfig, managerId);
  };

  render() {
    const {
      scorecardOptions = [],
      scoresOptions = [],
      managerInfo,
      adminView = false,
      useScorecardTabs = false,
    } = this.props;

    const scorecardSelectOptions = [{label: 'All', value: 'ALL'}].concat(
      scorecardOptions.map(scorecard => {
        return {
          label: scorecard.name,
          value: scorecard.id,
        };
      })
    );

    const myScoresLabel = adminView
      ? managerInfo
        ? managerInfo.firstName + "'s Scores"
        : "Manager's Scores"
      : 'My Scores';

    const displayScoresOptions = [{label: myScoresLabel, value: 'MY_SCORES'}].concat(
      scoresOptions.filter(option => option.value !== 'MY_SCORES')
    );

    return (
      <WidgetHeader {...this.props} showDates={true} title={this.props.label}>
        <WebDataButton onClick={this.webDataOnClick} tooltip="Export" />
        {useScorecardTabs
          ? this.renderScoresDropdown(displayScoresOptions)
          : this.renderParameters(scorecardSelectOptions, displayScoresOptions)}
        {!this.props.hidePeriod && (
          <DashboardDropdown
            selectedItem={this.props.selectedTimeframe}
            selectionOptions={TIMEFRAME_OPTIONS}
            updateSelection={this.props.updatePeriod}
            textProperty="text"
            keyProperty="key"
          />
        )}
      </WidgetHeader>
    );
  }
}

SAWHeader.displayName = 'SAW-Header';
export default SAWHeader;
